import { render, staticRenderFns } from "./AnexoConab.vue?vue&type=template&id=982438b6&scoped=true&"
import script from "./AnexoConab.vue?vue&type=script&lang=js&"
export * from "./AnexoConab.vue?vue&type=script&lang=js&"
import style0 from "./AnexoConab.vue?vue&type=style&index=0&id=982438b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982438b6",
  null
  
)

export default component.exports